import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useState } from '@web-stories-wp/react';
import { v4 as uuidv4 } from 'uuid';
import { __ } from '@web-stories-wp/i18n';
import { getTextInnerGlow } from '../../../../elements/text/utils/getTextInnerGlow';
import { TextInnerGlowFilter } from '../../../../elements/text/svgTextDisplay/textInnerGlowFilter';

const Preview = styled.svg`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  border: 1px solid ${({ theme }) => theme.colors.divider.primary};
  border-radius: 4px;
`;

export default function TextInnerGlowPreview({ textInnerGlow }) {
  const [id] = useState(() => `glow-square-preview-${uuidv4()}`);
  const glow = getTextInnerGlow(textInnerGlow);
  return (
    <Preview
      viewBox="-12 -12 88 88"
      role="img"
      aria-label={__('Inner Glow preview', 'web-stories')}
    >
      {glow && (
        <defs>
          <TextInnerGlowFilter id={id} glow={glow} width={64} height={64} />
        </defs>
      )}
      <rect
        width={64}
        height={64}
        fill="#808080"
        filter={glow ? `url(#${id})` : undefined}
      />
    </Preview>
  );
}
TextInnerGlowPreview.propTypes = { textInnerGlow: PropTypes.object.isRequired };
